var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lu-vbox',{staticClass:"app-container vpad-in-5",attrs:{"lu-flex":""}},[_c('lu-vbox',[_c('PageHeader',{attrs:{"title":"I-Risk Monitor View"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }